module.exports = __webpack_public_path__ + "luar.jpg?e2da414e6abf9a0393549a1b677c2e80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/luar.jpg
// module id = 132
// module chunks = 0